export const config = {
  GRAPHQL_URL: process.env.GRAPHQL_URL,
  SHOPPER_URL: process.env.SHOPPER_URL,
  OPENPIX_API: process.env.OPENPIX_API,
  GRAPHQL_SUBSCRIPTION_URL: process.env.GRAPHQL_SUBSCRIPTION_URL,
  SENTRY_DSN: process.env.SENTRY_DSN,
  COMMIT_SHA: process.env.COMMIT_SHA,
  OPENPIX_ENV: process.env.OPENPIX_ENV,
  BUILD_TIMESTAMP: process.env.BUILD_TIMESTAMP,
  APP_ENV: process.env.APP_ENV,
  CLARITY_ID: process.env.CLARITY_ID,
  ENTRYPOINT: process.env.ENTRYPOINT,
  CLICK_PIX_HOSTNAME: process.env.CLICK_PIX_HOSTNAME as string,

  IS_RSPACK: process.env.IS_RSPACK as string,
} as const;
